<script setup lang="ts">
import { useTemplateRef, watch } from "vue"
import { useElementSize } from "@vueuse/core"

import { useAppHeader } from "@/composables/useAppHeader"

const el = useTemplateRef<HTMLElement>("el")
const { height } = useElementSize(el)
const { headerPadding } = useAppHeader()

watch(height, (value) => (headerPadding.value = value), { immediate: true })
</script>

<template>
  <header
    ref="el"
    class="border-af-grey-300 bg-af-white/40 fixed top-0 left-0 z-100 w-full border-b px-5 backdrop-blur-xs"
  >
    <slot />
  </header>
</template>
